<template>
  <div>
    <b-dropdown text="Dropdown Button" class="m-md-2">
      <template v-for="option in options">
        <b-dropdown-item :key="option.id" :value="option.id" @click="selected = option.id">
          <slot name="item" :option="option"></slot>
        </b-dropdown-item>
      </template>
    </b-dropdown>
  </div>
</template>

<script>
export default {

  props: ['options', 'value'],

  data: function () {
    return {
      selected: null
    }
  }
}
</script>